import React from 'react'
import { Link } from 'react-router-dom'
import { hasUserPermissionOnMegaMenuGroupItem, hasUserPermission } from '../../utils/permissionHelper'

export const leads = [
  {
    label: 'Approval Queue',
    link: '/lead?filter=pending_approval',
    permission: 'lead_approval_queue_read',
  },
  {
    label: 'All',
    link: '/lead',
    permission: 'lead_read',
  },
  {
    label: 'Pending',
    link: '/lead?filter=pending',
    permission: 'lead_read',
  },
  {
    label: 'Pending Verification',
    link: '/lead?filter=pending_verification',
    permission: 'lead_read',
  },
  {
    label: 'Pending Manual Verification',
    link: '/lead?filter=pending_manual_verification',
    permission: 'lead_read',
  },
  {
    label: 'Withdrawn Leads Requiring AA',
    link: '/withdrawn_leads',
    permission: 'lead_read',
  },
]

export const loans = [
  {
    label: 'All',
    link: '/loan',
    permission: 'loan_read',
  },
  {
    label: 'Unscheduled Balances',
    link: '/loan?filter=unscheduled_balance',
    permission: 'loan_read',
  },
  {
    label: 'Un-Fixed Correction Codes',
    link: '/loan?filter=payment_correction',
    permission: 'loan_read',
  },
  {
    label: 'Payment Missed',
    link: '/loan?filter=payment_missed',
    permission: 'loan_read',
  },
  {
    label: 'Pending Void',
    link: '/loan?filter=pending_void',
    permission: 'loan_read',
  },
  {
    label: 'Pending Cancellation',
    link: '/loan?filter=pending_cancellation',
    permission: 'loan_read',
  },
  {
    label: 'Pending Early Payoff',
    link: '/loan?filter=pending_early_payoff',
    permission: 'loan_read',
  },
  {
    label: 'Loan Signatures',
    link: '/loan_signature',
    permission: 'loan_signature_read',
  },
]

export const payments = [
  {
    label: 'All',
    link: '/payment',
    permission: 'payment_read',
  },
  {
    label: 'In Queue',
    link: '/payment?filter=in_queue',
    permission: 'payment_read',
  },
  {
    label: 'In Process',
    link: '/payment?filter=in_process',
    permission: 'payment_read',
  },
  {
    label: 'Returned',
    link: '/payment?filter=returned',
    permission: 'payment_read',
  },
  {
    label: 'Error Processing',
    link: '/payment?filter=error_processing',
    permission: 'payment_read',
  },
  {
    label: 'C-Code Paid',
    link: '/payment?filter=c_code_paid',
    permission: 'payment_read',
  },
  {
    label: 'On Hold',
    link: '/payment?filter=hold',
    permission: 'payment_read',
  },
  {
    label: 'Wire Approval Queue',
    link: '/wire_approval_queue',
    permission: 'payment_read',
  },
  {
    label: 'Payment Failed Queue',
    link: '/module_queue/payment/action_type_failed_payments',
    permission: 'payment_read',
  },
]

export const check_processings = [
  {
    label: 'Payment Check Batches',
    link: '/payment_check_batch',
    permission: 'payment_check_batch_read',
  },
  {
    label: 'Bulk Check Entry',
    link: '/bulk_check_entry',
    permission: 'payment_check_batch_create',
  },
]

export const customers = [
  {
    label: 'All',
    link: '/customer',
    permission: 'customer_read',
  },
  {
    label: 'Current Lead',
    link: '/customer?filter=current_lead',
    permission: 'customer_read',
  },
  {
    label: 'Current Loan',
    link: '/customer?filter=current_loan',
    permission: 'customer_read',
  },
  {
    label: 'Fundable',
    link: '/customer?filter=fundable',
    permission: 'customer_read',
  },
  {
    label: 'Non-Fundable',
    link: '/customer?filter=non_fundable',
    permission: 'customer_read',
  },
  {
    label: 'Non-Fundable State Changes',
    link: '/non_fundable_state_change',
    permission: 'customer_read',
  },
]

export const associated_helpers = [
  {
    label: 'Bank Accounts',
    link: '/bank_account',
    permission: 'bank_account_read',
  },
  {
    label: 'Debit Cards',
    link: '/customer_debit_card',
    permission: 'customer_debit_card_read',
  },
  {
    label: 'Customer Notes',
    link: '/customer_note',
    permission: 'customer_note_read',
  },
  {
    label: 'Exclusion List',
    link: '/exclusion_list',
    permission: 'exclusion_list_read',
  },
  {
    label: 'Surveys',
    link: '/customer_survey',
    permission: 'customer_survey_read',
  },
]

export default function NavLead(props) {
  return (
    <div className="navbar-dropdown lox-navigation-bar__content__dropdown is-block p-0">
      <div className=" m-0 p-3 is-size-7 lox-navigation-bar__content__dropdown__container">
        {hasUserPermissionOnMegaMenuGroupItem(props.userPermissions, customers) && (
          <div className="mt-2">
            <h2 className="title is-size-5 mb-0 has-text-primary">Customers</h2>
            {customers.map(
              (customer, i) =>
                hasUserPermission(props.userPermissions, customer.permission) && (
                  <Link
                    className="navbar-item"
                    to={`${customer.link}`}
                    onClick={props.onLink}
                    key={customer.permission + `${i}`}
                  >
                    {customer.label}
                  </Link>
                )
            )}
          </div>
        )}

        {hasUserPermissionOnMegaMenuGroupItem(props.userPermissions, leads) && (
          <div className="mt-2">
            <h2 className="title is-size-5 mb-0 has-text-primary">Leads</h2>
            {leads.map(
              (lead, i) =>
                hasUserPermission(props.userPermissions, lead.permission) && (
                  <Link
                    className="navbar-item"
                    to={`${lead.link}`}
                    onClick={props.onLink}
                    key={lead.permission + `${i}`}
                  >
                    {lead.label}
                  </Link>
                )
            )}
          </div>
        )}

        {hasUserPermissionOnMegaMenuGroupItem(props.userPermissions, loans) && (
          <div className="mt-2">
            <h2 className="title is-size-5 mb-0 has-text-primary">Loans</h2>
            {loans.map(
              (loan, i) =>
                hasUserPermission(props.userPermissions, loan.permission) && (
                  <Link
                    className="navbar-item"
                    to={`${loan.link}`}
                    onClick={props.onLink}
                    key={loan.permission + `${i}`}
                  >
                    {loan.label}
                  </Link>
                )
            )}
          </div>
        )}

        {hasUserPermissionOnMegaMenuGroupItem(props.userPermissions, payments) && (
          <div className="mt-2">
            <h2 className="title is-size-5 mb-0 has-text-primary">Payments</h2>
            {payments.map(
              (payment, i) =>
                hasUserPermission(props.userPermissions, payment.permission) && (
                  <Link
                    className="navbar-item"
                    to={`${payment.link}`}
                    onClick={props.onLink}
                    key={payment.permission + `${i}`}
                  >
                    {payment.label}
                  </Link>
                )
            )}
          </div>
        )}

        {hasUserPermissionOnMegaMenuGroupItem(props.userPermissions, check_processings) && (
          <div className="mt-2">
            <h2 className="title is-size-5 mb-0 has-text-primary">Check Processing</h2>
            {check_processings.map(
              (element, i) =>
                hasUserPermission(props.userPermissions, element.permission) && (
                  <Link
                    className="navbar-item"
                    to={`${element.link}`}
                    onClick={props.onLink}
                    key={element.permission + `${i}`}
                  >
                    {element.label}
                  </Link>
                )
            )}
          </div>
        )}

        {hasUserPermissionOnMegaMenuGroupItem(props.userPermissions, associated_helpers) && (
          <div className="mt-2">
            <h2 className="title is-size-5 mb-0 has-text-primary">Associated Helpers</h2>
            {associated_helpers.map(
              (helper) =>
                hasUserPermission(props.userPermissions, helper.permission) && (
                  <Link
                    className="navbar-item"
                    to={`${helper.link}`}
                    onClick={props.onLink}
                    key={helper.permission}
                  >
                    {helper.label}
                  </Link>
                )
            )}
          </div>
        )}

      </div>
    </div>
  )
}
